export default "__VITE_ASSET__NHEZnzsq__"